import { useMemo } from 'react';
import { pm2ConfigStore } from '@pm2/store';
import { transformAST } from '@utils/ast';
import { useActiveRevision } from './hook.active-revision.js';
import { useCourseRevisionState } from './store.js';

/**
 * returns the AST after the currently matching revision has been applied.
 */
function useRevisedContentAST(ast, descriptor, courseId) {
  const areCourseRevisionsEnabled = pm2ConfigStore.useSelector(state => state.config.settings.showCoursePlanner);
  const isEditing = useCourseRevisionState(state => state.isEditing);
  const activeRevision = useActiveRevision(courseId);
  const transformedAST = useMemo(() =>
  // When editing all nodes should be available, dimming etc. will instead
  // be handled by printers.
  !areCourseRevisionsEnabled || isEditing || !activeRevision ? ast : transformAST(ast, node => {
    const isLayoutElement = ["grid-component", "grid-component.column", "accordion-component", "accordion-component.panel"].includes(node.nodeType);
    const disabledOnChapterLevel = descriptor && activeRevision.disabledContentIds[descriptor.id]?.disabled;
    const disabledOnNodeLevel = descriptor && "pm2" in node && "id" in node && node.id && activeRevision?.disabledContentIds[descriptor.id]?.[node.id];

    // in case the current node should be considered disabled, then
    // remove it from the resulting AST
    if (!isLayoutElement && (disabledOnChapterLevel || disabledOnNodeLevel)) {
      return null;
    }
    return node;
  }), [areCourseRevisionsEnabled, isEditing, activeRevision, ast, descriptor]);
  return transformedAST;
}

export { useRevisedContentAST };
//# sourceMappingURL=hook.course-revision-ast.js.map
